define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../shared/dataLogs", "../../models/UserContext", "./serverActions"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DataLogs, UserContext, ServerActions) {
    "use strict";
    var Servers = /** @class */ (function () {
        function Servers() {
            this.filterByAny = ko.observable("");
            this.canExport = UserContext.hasAccess("Admin,Servers.Export");
            this.serverActions = new ServerActions();
        }
        Servers.prototype.init = function () {
            var self = this;
            $("#page-title").text("Servers");
            tools.ajaxGet({
                url: "/Servers/GetServersLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.serversLookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.initGrid(self.serversLookupLists.GridStructures.ServersStructure);
                    self.serverActions.saveCallback = function (resultData) {
                        if (resultData) {
                            window.location.assign("/Servers/Details/" + resultData.Id);
                        }
                    };
                    $(".js-new-server").on("click", function (event) {
                        self.serverActions.editServer();
                        event.preventDefault();
                    });
                    ko.applyBindings(self, document.getElementById("main-container"));
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        Servers.prototype.initGrid = function (gridStructure) {
            var _this = this;
            var self = this;
            var columns = gridStructure.columns;
            //add actions column
            var statusColumn = {
                field: "",
                title: 'Status',
                width: "50px",
                template: function (dataItem) {
                    /*if (dataItem.CloudStorageEnabled) {
                        tools.ajaxGet({
                            url: "/Servers/GetCloudSyncAppStatus?ipAddress=" + dataItem.IpAddress
                        }).done((result) => {
                            dataItem.syncStatus = result;
                            //console.log(result);
                            //console.log(result.queues);
                            //console.log(result.queues.isReady);
                            var id = `async_${dataItem.IpAddress}`;
                            var elm = document.getElementById(id);
                            console.log(elm);
                            if (result != null && result.queues != null && result.queues.isReady) {
                                $(elm).html(`<div class="text-center text-success show-details" ><i class="fa fa-check-circle"></i></div>`);
                            } else {
                                $(elm).html(`<div class="text-center text-warning show-details"><i class="fa fa-ban"></i></div>`);
                            }
    
                            console.log(elm);
                        }).fail((e) => {
                            var id = `async_${dataItem.IpAddress}`;
                            var elm = document.getElementById(id);
                            dataItem.syncStatus = e;
                            $(elm).html(`<div class="text-center text-warning show-details"><i class="fa fa-ban"></i></div>`);
                        });
                    }*/
                    return "<div id='async_" + dataItem.IpAddress + "'></div>";
                }
            };
            var actions = {
                field: "",
                width: "250px",
                template: function (dataItem) {
                    var html = "";
                    if (UserContext.hasAccess("Admin,CanLoginAutomatically")) {
                        if (dataItem.LoginTypeName == 'V6') {
                            html += "<a class=\"btn btn-sm btn-success btn-v6-login\" data-ipaddress=\"".concat(dataItem.IpAddress, "\" href=\"#\"><i class=\"fa fa-lock \"></i>&nbsp;Login</a>&nbsp;");
                        }
                        else {
                            html += '<a class="btn btn-sm btn-success btn-login" target="_blank" href="/Servers/MultipleLogin?url=' + dataItem.IpAddress + '"><i class="fa fa-lock "></i>&nbsp;Login</a>&nbsp;';
                        }
                    }
                    html += '<a class="btn btn-sm btn-yellow btn-edit" href="/Servers/Details/' + dataItem.Id + '"><i class="fa fa-edit "></i>&nbsp;View</a>';
                    if (UserContext.hasAccess("Admin,Servers.Delete")) {
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i>&nbsp;Delete</button>';
                    }
                    return html;
                }
            };
            columns.push(statusColumn);
            columns.push(actions);
            self.serversTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Servers/GetServers",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($("#servers-toolbar-template").html()),
                    columns: columns,
                    autoBind: true,
                    resizable: true,
                    reorderable: true,
                    //mobile: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row",
                        extra: false
                    },
                },
                enableExport: {
                    entityName: "Server",
                    title: "Servers",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: true
                },
                gridId: "tblServersKendo",
                showPagerOnTop: false,
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.serversTable.initGrid(gridOptions);
            $("#tblServersKendo tbody").on("click", ".btn-remove", function (event) {
                var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                _this.serverActions.deleteServerConfirm(dataItem.Id, dataItem.IpAddress);
                event.preventDefault();
            }).on("click", ".btn-v6-login", function (event) {
                var ipaddress = $(event.currentTarget).data('ipaddress');
                self.serverActions.loginToServer(ipaddress, null);
                event.preventDefault();
            });
            self.serverActions.deleteCallback = function () {
                _this.serversTable.getGridData().dataSource.read();
            };
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.serversTable.getGridData().dataSource.read();
            });
            $("#tblServersKendo").kendoTooltip({
                autoHide: false,
                showOn: "click",
                position: "left",
                filter: ".show-details",
                //width: 200,
                show: function (e) {
                    this.popup.element.addClass("logs-tool-tip");
                },
                content: function (e) {
                    var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(e.target);
                    var formatedData = "<pre>".concat(JSON.stringify(dataItem.syncStatus, null, 4), "</pre>");
                    return formatedData;
                }
            }).data("kendoTooltip");
        };
        Servers.prototype.checkPbxStatus = function () {
            var self = this;
            var dataItems = self.serversTable.getGridData().dataSource.view();
            for (var i = 0; i < dataItems.length; i++) {
                var dataItem = dataItems[i];
                self.getPbxStatus(dataItem);
            }
        };
        Servers.prototype.getPbxStatus = function (dataItem) {
            if (dataItem.CloudStorageEnabled) {
                tools.ajaxGet({
                    url: "/Servers/GetCloudSyncAppStatus?ipAddress=" + dataItem.IpAddress
                }).done(function (result) {
                    dataItem.syncStatus = result;
                    //console.log(result);
                    //console.log(dataItem);
                    //console.log(result.queues);
                    //console.log(result.queues.isReady);
                    var id = "async_".concat(dataItem.IpAddress);
                    var elm = document.getElementById(id);
                    console.log(elm);
                    if (result != null && result.queues != null && result.queues.isReady) {
                        $(elm).html("<div class=\"text-center text-success show-details\" ><i class=\"fa fa-check-circle\"></i></div>");
                    }
                    else {
                        $(elm).html("<div class=\"text-center text-warning show-details\"><i class=\"fa fa-ban\"></i></div>");
                    }
                    console.log(elm);
                }).fail(function (e) {
                    var id = "async_".concat(dataItem.IpAddress);
                    var elm = document.getElementById(id);
                    dataItem.syncStatus = e;
                    $(elm).html("<div class=\"text-center text-warning show-details\"><i class=\"fa fa-ban\"></i></div>");
                });
            }
        };
        Servers.prototype.clearFilter = function () {
            var self = this;
            self.filterByAny("");
        };
        Servers.prototype.exportTo = function () {
            var self = this;
            if (self.canExport) {
                self.serversTable.exportTo();
            }
        };
        Servers.prototype.showLogs = function () {
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("Server");
                dataLogs.open("Servers logs");
                event.preventDefault();
            }
        };
        return Servers;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Servers/Index")) {
            log.log("Initialize Servers list");
            $(function () {
                (new Servers()).init();
            });
        }
    }, 0);
    return Servers;
});
//# sourceMappingURL=servers.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/servers/servers.js
// module id = 243
// module chunks = 2